<div *ngIf="toastService.message() as msg" class="toast" [class.error]="msg.type === 'error'" [class.success]="msg.type === 'success'">
  <span class="toast-icon" aria-hidden="true"></span>
  <span class="toast-text">{{ msg.text }}</span>
</div>